import { TaskGroupTemplate } from '@this+that/models';
import { create } from 'zustand';

interface State {
  byGroup: Record<string, TaskGroupTemplate[]>;
  loadedGroups: Set<string>;
  loadingByGroup: Record<string, boolean>;
}

interface Actions {
  setForGroup(taskGroupId: string, templates: TaskGroupTemplate[]): void;
  upsert(template: TaskGroupTemplate): void;
  remove(taskGroupId: string, id: string): void;
  setGroupLoading(taskGroupId: string, loading: boolean): void;
  resetState(): void;
}

export const useTaskGroupTemplatesStore = create<State & Actions>((set) => ({
  byGroup: {},
  loadedGroups: new Set(),
  loadingByGroup: {},
  setForGroup: (taskGroupId, templates) =>
    set((s) => ({
      byGroup: { ...s.byGroup, [taskGroupId]: templates },
      loadedGroups: new Set(s.loadedGroups).add(taskGroupId),
    })),
  upsert: (template) =>
    set((s) => {
      const list = s.byGroup[template.taskGroupId] ?? [];
      const idx = list.findIndex((t) => t.id === template.id);
      const next =
        idx === -1
          ? [...list, template]
          : list.map((t) => (t.id === template.id ? template : t));
      return { byGroup: { ...s.byGroup, [template.taskGroupId]: next } };
    }),
  remove: (taskGroupId, id) =>
    set((s) => ({
      byGroup: {
        ...s.byGroup,
        [taskGroupId]: (s.byGroup[taskGroupId] ?? []).filter(
          (t) => t.id !== id,
        ),
      },
    })),
  setGroupLoading: (taskGroupId, loading) =>
    set((s) => ({
      loadingByGroup: { ...s.loadingByGroup, [taskGroupId]: loading },
    })),
  resetState: () =>
    set({ byGroup: {}, loadedGroups: new Set(), loadingByGroup: {} }),
}));
